/* VT-3: desktop gallery edge arrows (docs/handoff/product-page).
   With gallery_layout 'thumbnail_slider' the desktop viewer is not a scroll
   slider - only the active media renders - so Dawn's native prev/next are
   inoperable there (global.js also marks them disabled). These overlay
   buttons delegate to the native thumbnail buttons instead: media switching,
   aria state and variant behaviour all stay Dawn's (media-gallery.js). */
(() => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    gallery.querySelectorAll('[data-gallery-nav]').forEach((button) => {
      button.addEventListener('click', () => {
        const thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
        if (thumbs.length < 2) return;
        const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
        const direction = button.dataset.galleryNav === 'next' ? 1 : -1;
        thumbs[(current + direction + thumbs.length) % thumbs.length].click();
      });
    });
  });
})();
